module.exports = __webpack_public_path__ + "static/media/18-holes-shot-3.f204dfe5.jpg";